import { jsx as _jsx } from "react/jsx-runtime";
export const validFullStoryLevels = ['exclude', 'mask', 'unmask'];
const FullStoryMask = _ref => {
  let {
    className,
    level = 'mask',
    inline = false,
    children,
    ...otherProps
  } = _ref;
  const classes = [`fs-${level}`];
  if (className) {
    classes.push(className);
  }
  if (inline) {
    return /*#__PURE__*/_jsx("span", {
      className: classes.join(' '),
      ...otherProps,
      "data-mesh-component": "FORM-CONTROL--FULL-STORY-MASK",
      children: children
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: classes.join(' '),
    ...otherProps,
    children: children
  });
};
export default FullStoryMask;